import PropTypes from "prop-types"
import React from "react"

const Header = () => (
  <header
    style={{
      margin: `3% auto`,
      maxWidth: "60%",
      minWidth: 30,
      marginLeft: "9%",
      marginBottom: "2%",
      textAlign: "left",
    }}
  >
    <div
      style={{
        margin: `0 auto`,
      }}
    >
      <h3 style={{ marginLeft: "10%", color: "#ff5858" }}>  Always Creating </h3>

    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
